/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeoCustomerNumber } from './HeoCustomerNumber';
import {
    HeoCustomerNumberFromJSON,
    HeoCustomerNumberFromJSONTyped,
    HeoCustomerNumberToJSON,
    HeoCustomerNumberToJSONTyped,
} from './HeoCustomerNumber';
import type { RegisteredClientIp } from './RegisteredClientIp';
import {
    RegisteredClientIpFromJSON,
    RegisteredClientIpFromJSONTyped,
    RegisteredClientIpToJSON,
    RegisteredClientIpToJSONTyped,
} from './RegisteredClientIp';
import type { ClientCredentials } from './ClientCredentials';
import {
    ClientCredentialsFromJSON,
    ClientCredentialsFromJSONTyped,
    ClientCredentialsToJSON,
    ClientCredentialsToJSONTyped,
} from './ClientCredentials';

/**
 * 
 * @export
 * @interface LiveClient
 */
export interface LiveClient {
    /**
     * 
     * @type {HeoCustomerNumber}
     * @memberof LiveClient
     */
    heoCustomerNumber: HeoCustomerNumber;
    /**
     * 
     * @type {ClientCredentials}
     * @memberof LiveClient
     */
    clientCredentials: ClientCredentials;
    /**
     * 
     * @type {Array<RegisteredClientIp>}
     * @memberof LiveClient
     */
    ips: Array<RegisteredClientIp>;
    /**
     * 
     * @type {Date}
     * @memberof LiveClient
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the LiveClient interface.
 */
export function instanceOfLiveClient(value: object): value is LiveClient {
    if (!('heoCustomerNumber' in value) || value['heoCustomerNumber'] === undefined) return false;
    if (!('clientCredentials' in value) || value['clientCredentials'] === undefined) return false;
    if (!('ips' in value) || value['ips'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function LiveClientFromJSON(json: any): LiveClient {
    return LiveClientFromJSONTyped(json, false);
}

export function LiveClientFromJSONTyped(json: any, ignoreDiscriminator: boolean): LiveClient {
    if (json == null) {
        return json;
    }
    return {
        
        'heoCustomerNumber': HeoCustomerNumberFromJSON(json['heoCustomerNumber']),
        'clientCredentials': ClientCredentialsFromJSON(json['clientCredentials']),
        'ips': ((json['ips'] as Array<any>).map(RegisteredClientIpFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function LiveClientToJSON(json: any): LiveClient {
    return LiveClientToJSONTyped(json, false);
}

export function LiveClientToJSONTyped(value?: LiveClient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'heoCustomerNumber': HeoCustomerNumberToJSON(value['heoCustomerNumber']),
        'clientCredentials': ClientCredentialsToJSON(value['clientCredentials']),
        'ips': ((value['ips'] as Array<any>).map(RegisteredClientIpToJSON)),
        'createdAt': value['createdAt'].toISOString(),
    };
}

